import { uri, errorLogger } from 'utils';

import types from '../types';
import { LISTING_SORTING_URL_PARAMETER } from '../constants';

/**
 * @param {types.SelectOption[]} availableSortingOptions
 * @param {string} url
 * @returns {?string}
 */
const getSelectedSortingFromURL = (availableSortingOptions, url) => {
    const urlParameter = uri.getParams(url)[LISTING_SORTING_URL_PARAMETER];

    if (!urlParameter) {
        return null;
    }

    if (
        !availableSortingOptions ||
        !Array.isArray(availableSortingOptions) ||
        !availableSortingOptions.length
    ) {
        errorLogger('Missing available sorting options!');

        return null;
    }

    if (availableSortingOptions.find(option => option.value === urlParameter)) {
        return urlParameter;
    }

    return null;
};

export default getSelectedSortingFromURL;
